import { z } from 'zod'
import type { FileSelectionPrecondition, FolderSelectionPrecondition } from '@/user_files/schemas/preconditions'

// =============================================================================
// Request Types (TypeScript only)
// =============================================================================

export type DeleteSelectionRequest = {
  file_ids?: string[]
  folder_ids?: string[]
  file_preconditions?: FileSelectionPrecondition[]
  folder_preconditions?: FolderSelectionPrecondition[]
}

// =============================================================================
// Response Schemas (Zod - runtime validated)
// =============================================================================

export const DeleteSelectionResponseSchema = z.object({
  deleted_file_ids: z.array(z.string().uuid()),
  deleted_folder_ids: z.array(z.string().uuid()),
  directly_deleted_file_ids: z.array(z.string().uuid()),
  directly_deleted_folder_ids: z.array(z.string().uuid()),
  unchanged_file_ids: z.array(z.string().uuid()),
  unchanged_folder_ids: z.array(z.string().uuid()),
})

export type DeleteSelectionResponse = z.infer<typeof DeleteSelectionResponseSchema>
